const RESET_FILTERS_ACCENT = "#FF8555";
const RESET_FILTERS_DISABLED = "rgba(0, 0, 0, 0.38)";

function FluentMdl2ResetIcon({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 2048 2048"
      aria-hidden
      focusable="false"
      style={{ display: "block", flexShrink: 0 }}
    >
      <path
        fill="currentColor"
        d="M1920 1216q0 115-30 221t-84 198t-130 169t-168 130t-199 84t-221 30q-115 0-221-30t-198-84t-169-130t-130-168t-84-199t-30-221v-64h128v64q0 97 25 187t71 168t110 142t143 111t168 71t187 25q97 0 187-25t168-71t142-110t111-143t71-168t25-187q0-97-25-187t-71-168t-110-142t-143-111t-168-71t-187-25H250l291 291l-90 90L6 448L451 3l90 90l-291 291h838q115 0 221 30t198 84t169 130t130 168t84 199t30 221"
      />
    </svg>
  );
}

export type ResetFiltersButtonProps = {
  disabled: boolean;
  onClick: () => void;
};

export function ResetFiltersButton({
  disabled,
  onClick,
}: ResetFiltersButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label="Reset filters"
      title={disabled ? "No filters applied" : "Clear all filters"}
      style={{
        boxSizing: "border-box",
        height: 36,
        minHeight: 36,
        padding: "0 14px",
        border: "none",
        borderRadius: 10,
        backgroundColor: "transparent",
        fontFamily: "Roboto, sans-serif",
        fontSize: 14,
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.00938em",
        color: disabled ? RESET_FILTERS_DISABLED : RESET_FILTERS_ACCENT,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        cursor: disabled ? "not-allowed" : "pointer",
        whiteSpace: "nowrap",
      }}
    >
      <FluentMdl2ResetIcon size={16} />
      Reset Filters
    </button>
  );
}
